import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import Pagination from 'components/Pagination/Pagination';
import { TableColumns } from 'helpers/tableColumns';
import { useRemoteResource } from 'hooks/useRemoteResource';
import duaCategoriesSAService from 'services/superadmin/duaCategoriesSAService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'name',
        label: 'Константа'
    },    
    {
        key: "status",
        label: "Статус",
        formatter: (v) => v ? 'Активный' : 'Неактивный'
    },
    TableColumns.createdDate,
]

export const DuaCategoryList = () => {
    const [data, loadData, loading] = useRemoteResource(duaCategoriesSAService.getAll, "");

    const onDelete = async (u) => {
        await duaCategoriesSAService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Список категорий">
            <AppAdminTable
                columnConfig={listConfig}
                data={data?.data || []}
                onDelete={onDelete}
                loading={loading}
            />
            {data && <Pagination total={data.total} limit={50} />}
        </ListPage>
    );
}
